/**
 * Converts German number format (e.g. "1.234,56 €") to a JavaScript number
 */
export function convertGermanNumber(value: string | number | null | undefined): string | number {
  if (!value || typeof value !== 'string') return value ?? '';

  // Check if it looks like a German currency/number format
  if (!value.includes('€') && !value.match(/^\d{1,3}(\.\d{3})*,\d{2}$/)) {
    return value;
  }

  const cleaned = value
    .replace(/[€\s]/g, '')
    .replace(/\./g, '')
    .replace(/,/g, '.');

  const parsed = parseFloat(cleaned);
  return isNaN(parsed) ? 0 : parsed;
}

/**
 * Formats a number as German currency (e.g. "1.234,56 €")
 */
export function formatGermanCurrency(value: number | null | undefined): string {
  if (value === null || value === undefined || value === 0) return '';

  return value.toLocaleString('de-DE', {
    style: 'currency',
    currency: 'EUR'
  });
}
